// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import { JOB_DETAILS } from "../../../utility/constants";
import axios from "axios";
import {
  FETCH_JOB_DETAILS_REQUEST,
  fetchJobDetailsSuccess,
  fetchJobDetailsFailure,
} from "../../actions/fetchJobDetailsActions";

function* fecthjobdetails(action) {
  try {
    const response = yield call(axios.get, JOB_DETAILS, {
      params: { job_id: action.payload},
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    if (response.status === 200 && response.data.status === "Success") {
      yield put(fetchJobDetailsSuccess(response.data));
    }
  } catch (error) {
    console.log("action",action.payload)
    yield put(fetchJobDetailsFailure(error.message));
  }
}

export function* jobdetailsSaga() {
  yield takeLatest(FETCH_JOB_DETAILS_REQUEST, fecthjobdetails);
}
export default jobdetailsSaga;
